import {
  Drawer as DrawerType,
  EfsMelcoEfsModelsSchemaListItem,
} from "melco-shared-logic";
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { FoldernameRuleForm } from "./FoldernameRuleForm";

type FoldernameRuleDrawerProps = {
  drawer: DrawerType;
  editFoldernameRuleIndex: number | undefined;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
};

export type FoldernameRuleFormMode = "add" | "edit";

export const FoldernameRuleDrawer: React.FC<FoldernameRuleDrawerProps> = ({
  drawer,
  editFoldernameRuleIndex,
  dataAssignments,
}) => {
  const { t } = useTranslation();

  const { closeDrawer, isDrawerOpen } = drawer;

  const isAddingNewRule = editFoldernameRuleIndex == null;

  const formMode = isAddingNewRule ? "add" : "edit";

  return (
    <Drawer
      title={t(
        `designMappings.actions.foldernameRules.actions.${formMode}.title`
      )}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
    >
      <FoldernameRuleForm
        drawer={drawer}
        editFoldernameRuleIndex={editFoldernameRuleIndex}
        formMode={formMode}
        dataAssignments={dataAssignments}
      />
    </Drawer>
  );
};
